import { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const SelectField = ({ children, value = '', onChange }) => {
  const [hasFocus, setHasFocus] = useState(false);

  const handleChange = e => {
    e.persist();
    onChange(e);
  };

  const handleBlur = e => setHasFocus(false);
  const handleFocus = e => setHasFocus(true);

  return (
    <SelectContainer value={value} focus={hasFocus}>
      <select onBlur={handleBlur} onFocus={handleFocus} onChange={handleChange}>
        {children}
      </select>
    </SelectContainer>
  );
};

SelectField.propTypes = {
  children: PropTypes.node,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default SelectField;

const SelectContainer = styled.div`
  display: grid;
  grid-template-areas: 'select';
  align-items: center;
  position: relative;
  font-size: 1.25rem;
  color: #000;
  background-color: ${({ focus }) => (focus ? '#d3e5f1' : '#dfecf4')};
  padding: 0;
  border-radius: 0;
  cursor: pointer;

  &:after {
    content: '';
    justify-self: end;
    width: 1em;
    height: 1em;
    background-color: #6e84be;
    clip-path: polygon(0 40%, 50% 80%, 100% 40%, 100% 60%, 50% 100%, 0 60%);
    grid-area: select;
    margin-right: 1rem;
  }

  select {
    appearance: none;
    width: 100%;
    background-color: transparent;
    border: none;
    border-bottom: 0.125rem solid #6e84be;
    margin: 0;
    padding: 0.75rem 0.875rem;
    font-size: inherit;
    cursor: inherit;
    grid-area: select;
    z-index: 1;
  }
`;
